import { Button } from '@cian/ui-kit/button';
import { InlineText3 } from '@cian/ui-kit/typography/InlineText';

import * as React from 'react';

import * as styles from './FormFooterWithPrivacyPolicy.css';
import { IFormFooterWithPrivacyPolicyProps } from './types';

export const FormFooterWithPrivacyPolicy: React.FC<IFormFooterWithPrivacyPolicyProps> = props => {
  const { submitButtonTitle, buttonDisabled, onButtonClick } = props;

  return (
    <div className={styles['form-footer']}>
      <div className={styles['privacy-policy-container']}>
        <InlineText3 as="span" color="black_100" fontWeight="normal">
          Нажимая на кнопку «{submitButtonTitle}», вы принимаете условия
        </InlineText3>
        <InlineText3 as="span" color="black_100" fontWeight="normal">
          <a
            target="_blank"
            className={styles['privacy-policy-link']}
            href="/legal-documents/licenzionnoe_soglashenie_0/"
          >
            пользовательского соглашения
          </a>
          {' и '}
          <a
            target="_blank"
            className={styles['privacy-policy-link']}
            href="/legal-documents/politika_konfidencialnosti_0/"
          >
            политики конфиденциальности
          </a>
        </InlineText3>
      </div>
      <div className={styles['submit-button-container']}>
        <Button disabled={buttonDisabled} onClick={onButtonClick} type="submit" size="XS" theme="fill_primary">
          {submitButtonTitle}
        </Button>
      </div>
    </div>
  );
};

FormFooterWithPrivacyPolicy.displayName = 'FormFooterWithPrivacyPolicy';
